/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Venue } from '@app/settings/venues/venue.model';
import { VenuesFormComponent } from '@app/settings/venues/venues-form/venues-form.component';

@Injectable({
  providedIn: 'root',
})
export class VenuesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open venue form
   * @param venue Dialog data
   */
  public open(venue: null | Venue = null) {
    let sentVenue = venue;
    if (!venue) {
        sentVenue = new Venue();
    }
    const modal = this.modalService.open(VenuesFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.venue = sentVenue;
    return modal.result;
  }
}
